const dateMask = 'DD.MM.YYYY'

export default dateMask
